import React, { useEffect, useState } from "react";
import { post } from "../../assets/Images/ImagesLink";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { ShimmerDiv } from "shimmer-effects-react";
import ModalForGuest from "../ModalForGuest";
import { Link } from "react-router-dom";
import { FaCalendarAlt } from "react-icons/fa";
import { IoIosChatboxes } from "react-icons/io";
import { FaTasks } from "react-icons/fa";
import { FaCube } from "react-icons/fa";
import { GoPersonFill } from "react-icons/go";
import Activities_timeline_Photo1 from "../../assets/Images/Activities/Activities_timeline_Photo1.jpg";
import Activities_timeline_Photo2 from "../../assets/Images/Activities/Activities_timeline_Photo2.jpg";
import Activities_timeline_Photo3 from "../../assets/Images/Activities/Activities_timeline_Photo3.jpg";
import Activities_timeline_Photo4 from "../../assets/Images/Activities/Activities_timeline_Photo4.jpg";
import FavoriteBorderSharpIcon from "@mui/icons-material/FavoriteBorderSharp";
import MoreHorizSharpIcon from "@mui/icons-material/MoreHorizSharp";

const Activities = ({ uid, getUserProfileStat }) => {
  const sessionId = localStorage.getItem("sessionId");
  const guestModeData = localStorage.getItem("guestMode");

  //************************ Follower  List   ************************/
  const [isError, setIsError] = useState(false);
  const [page, setPage] = useState(1);
  const [FollowerList, setFollowerList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  console.log("FollowerList", FollowerList);
  const [nextBatchLoading, setNextBatchLoading] = useState(false);
  const [hasMoreData, setHasMoreData] = useState(true);

  const handleInfiniteScroll = async () => {
    try {
      if (
        window.innerHeight + document.documentElement.scrollTop + 1 >=
        document.documentElement.scrollHeight
      ) {
        // setLoading(true);
        setPage((prev) => prev + 1);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleInfiniteScroll);
    return () => window.removeEventListener("scroll", handleInfiniteScroll);
  }, []);
  //************************Follower List ************************//
  //************************ Follow User Start  ************************//
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  //************************ Follow User End  ************************//
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      document.body.classList.add("modal-open"); // When a modal opens
    } else {
      document.body.style.overflow = "unset";
      document.documentElement.style.overflow = "";
      document.body.classList.remove("modal-open"); // When a modal closes
    }
  }, [showModal]);

  const [followModal, setFollowModal] = useState(false);
  const closeModalData = () => {
    setFollowModal(false);
  };

  return (
    <>
      {!isLoading ? (
        <div className="mt-3">
          {/* <ShimmerThumbnail height={250} rounded /> */}
          <ShimmerDiv mode="light" height={250} width={"100%"} />
        </div>
      ) : isError ? (
        <div className="mt-2 text-center">
          <img src={post.errorSmall} alt="404 Not Found" width={200} />
        </div>
      ) : (
        <div className="aboutMe mb-3 p-3">
          {/* // START DESIGN FROM HEREE */}
          <div className="Activities_Heading">
            <h2>Activities</h2>
          </div>
          <div className="Activities_Heading_Content">
            <h4>Today</h4>
            <ul className="Activities_timeline">
            <Link>
                <li className="Activities_timeline-item">
                  <div className="Activities_timeline-figure">
                    <span className="Activities_timeline-figure_inner">
                      {/* <FaCalendarAlt /> */}
                      <img src={Activities_timeline_Photo1} alt="" />
                    </span>
                  </div>
                  <div className="Activities_timeline-body">
                    <div className="Activities_timeline-body_MiddleContent">
                      <h6>
                        <Link to="">Ali shaikh Shaikh</Link>
                      <div className="Activities_timeline-body_MiddleContent_Date">
                        <span>liked your post</span>
                      </div>
                      </h6>
                        <div className="Activities_timeline-body_MiddleContent_Date2">
                          <p>3 hours ago</p>
                        </div>
                    </div>
                    <div className="Activities_timeline-body_MiddleContent_Likeanddot">
                      <div className="Activities_timeline-body_MiddleContent_Likeanddot_Icon">
                        <FavoriteBorderSharpIcon className="ActivityHeartIcon" />
                      </div>
                      <div className="Activities_timeline-body_MiddleContent_Likeanddot_IconDot">
                        <MoreHorizSharpIcon className="ActivityDotIcon" />
                      </div>
                    </div>
                  </div>
                </li>
              </Link>
              <Link>
                <li className="Activities_timeline-item">
                  <div className="Activities_timeline-figure">
                    <span className="Activities_timeline-figure_inner">
                      {/* <FaCalendarAlt /> */}
                      <img src={Activities_timeline_Photo1} alt="" />
                    </span>
                  </div>
                  <div className="Activities_timeline-body">
                    <div className="Activities_timeline-body_MiddleContent">
                      <h6>
                        <Link to="">Ali shaikh Shaikh</Link>
                      <div className="Activities_timeline-body_MiddleContent_Date">
                        <span>liked your post</span>
                      </div>
                      </h6>
                        <div className="Activities_timeline-body_MiddleContent_Date2">
                          <p>3 hours ago</p>
                        </div>
                    </div>
                    <div className="Activities_timeline-body_MiddleContent_Likeanddot">
                      <div className="Activities_timeline-body_MiddleContent_Likeanddot_Icon">
                        <FavoriteBorderSharpIcon className="ActivityHeartIcon" />
                      </div>
                      <div className="Activities_timeline-body_MiddleContent_Likeanddot_IconDot">
                        <MoreHorizSharpIcon className="ActivityDotIcon" />
                      </div>
                    </div>
                  </div>
                </li>
              </Link>
            </ul>
          </div>
          <div className="Activities_Heading_Content">
            <h4>Yesterday</h4>
            <ul className="Activities_timeline">
              <Link>
                <li className="Activities_timeline-item">
                  <div className="Activities_timeline-figure">
                    <span className="Activities_timeline-figure_inner">
                      {/* <FaTasks /> */}
                      <img src={Activities_timeline_Photo1} alt="" />
                    </span>
                  </div>
                  <div className="Activities_timeline-body">
                    <div className="Activities_timeline-body_MiddleContent">
                      <h6>
                        <input type="checkbox" name="" id="" />{" "}
                        <Link to=""> Daily Report - Dealing targeting</Link>
                      </h6>
                      <p>
                        <Link>Arthur Carroll </Link>created a todo on task
                      </p>
                    </div>
                    <div className="Activities_timeline-body_MiddleContent_Date">
                      <span>8:14pm</span>
                    </div>
                  </div>
                </li>
              </Link>
            </ul>
          </div>
          <div className="Activities_Heading_Content">
            <h4>January 25, 2018</h4>
            <ul className="Activities_timeline">
              <Link>
                <li className="Activities_timeline-item">
                  <div className="Activities_timeline-figure">
                    <span className="Activities_timeline-figure_inner">
                      <FaCube />
                    </span>
                  </div>
                  <div className="Activities_timeline-body">
                    <div className="Activities_timeline-body_MiddleContent">
                      <h6>
                        <Link to="">Project updated by Sara Carr</Link>
                      </h6>
                      <p>
                        <Link>Sara Carr</Link> updated <b>Online Store App</b>{" "}
                        to <Link>Online Store</Link>
                      </p>
                    </div>
                    <div className="Activities_timeline-body_MiddleContent_Date">
                      <span>3:21am</span>
                    </div>
                  </div>
                </li>
              </Link>
              <Link>
                <li className="Activities_timeline-item">
                  <div className="Activities_timeline-figure">
                    <span className="Activities_timeline-figure_inner">
                      <FaTasks />
                    </span>
                  </div>
                  <div className="Activities_timeline-body">
                    <div className="Activities_timeline-body_MiddleContent">
                      <h6>
                        <Link to="">Someone assigned you to a task</Link>
                      </h6>
                      <p>
                        <Link>Angela Peterson</Link> assign{" "}
                        <Link>Make lemonade from scratch</Link> to you
                      </p>
                    </div>
                    <div className="Activities_timeline-body_MiddleContent_Date">
                      <span>5:21pm</span>
                    </div>
                  </div>
                </li>
              </Link>
              <Link>
                <li className="Activities_timeline-item">
                  <div className="Activities_timeline-figure">
                    <span className="Activities_timeline-figure_inner">
                      <GoPersonFill />
                    </span>
                  </div>
                  <div className="Activities_timeline-body">
                    <div className="Activities_timeline-body_MiddleContent">
                      <h6>
                        <Link to="">You have new followers</Link>
                      </h6>
                      <div className="Activities_timeline_Photo">
                        <a href="">
                          <img src={Activities_timeline_Photo1} alt="" />
                        </a>
                        <a href="">
                          <img src={Activities_timeline_Photo2} alt="" />
                        </a>
                        <a href="">
                          <img src={Activities_timeline_Photo3} alt="" />
                        </a>
                        <a href="">
                          <img src={Activities_timeline_Photo4} alt="" />
                        </a>
                      </div>
                      <p>
                        <Link>Willie Dixon</Link> and 3 others followed you
                      </p>
                    </div>
                    <div className="Activities_timeline-body_MiddleContent_Date">
                      <span>10:32pm</span>
                    </div>
                  </div>
                </li>
              </Link>
            </ul>
          </div>
        </div>
      )}
      {/* {hasMoreData ? "" : <p className="text-center">No more data available</p>}
      {nextBatchLoading && (
        <div className="text-center mb-4">
          <img src={post?.loader} width={50} />
        </div>
      )} */}

      {followModal && <ModalForGuest closeModalData={closeModalData} />}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </>
  );
};

export default Activities;
